import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Route, Routes, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { decryptUrlDatapattern, encryptUrlDatapattern } from "../../../../components/commonClass/EncFunc";
import { loaderActions } from "../../../../_actions/loader.actions";
import { postUsersData, verifytoken } from "../../../../services/ApiCallingUserServices";
import { ClearLocalStorage, GetLocalStorage } from "../../../../components/commonClass/Session";
import { isValidEmail, isValidPAN } from "../../../../components/commonClass/CommonValidation";
import { fetchIp } from "../../../../components/commonClass/CommonFunctions";
import BookingRoomDetails from "./Partial/BookingRoomDetails";
import HotelBookingConfirmation from "../../BookingConfirmScreen/Hotels/HotelBookingConfirmation";


const HotelsDetailsReview = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handlePage = (name: any) => {
        const newSearchParams = new URLSearchParams(searchParams);
        navigate({ pathname: `/hotel/` + name, search: newSearchParams.toString() },
            { state: location?.state })
    }

    const [personcount, setPersonCont] = useState<any>({});
    const [getDataList, setGetDataList] = useState([]);
    const [convenienceDetail, setConvenienceDetail] = useState<any>([]);
    const [passengersData, setPassengersData] = useState([]);
    const APIBadMessage = 'Something went wrong, Please try again!';

    //------------------form state---------------------
    const [formError, setFormError] = useState({});
    const [insertCollection, setInsertCollection] = useState<any>(null);
    const [initialData, setInitialData] = useState([]);

    const [formValue, setFormValue] = useState<any>(null)
    const [intOtherData, setIntOtherData] = useState([]);
    var razorpopup = document.getElementsByClassName('razorpay-container');
    const gstinregex = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9]{1}Z[0-9A-Z]{1}$/);
    const foreignNationalityMessage = "Booking not allowed for foreign nationality traveler in a foreign hotel."

    const newSearchParams = useMemo(() => {
        return new URLSearchParams(searchParams);
    }, [searchParams])

    const isinternationalhotel = sessionStorage?.getItem('isinternationalhotel') === 'true' ? true : false;

    const showPAN = (CountryId: any) => {
        return [1]?.includes(CountryId) && isinternationalhotel;
    }

    const showPassport = (CountryId: any) => {
        return isinternationalhotel ? true : ![0, 1]?.includes(CountryId);
    }

    const checkPathName = location?.pathname?.includes('Booking-successful') || location?.pathname?.includes('failed') || location?.pathname?.includes('pending') || location?.pathname?.includes('on-hold');

    useEffect(() => {
        const isRetry = localStorage.getItem("isRetry") !== null ? decryptUrlDatapattern(localStorage.getItem("isRetry")) : null;
        if (location?.pathname?.includes('payment') && isRetry !== "true") {
            window.history.forward();
        }
    }, [location])

    const passengerCount = useMemo(() =>
        location?.state?.PaxRooms?.reduce((acc: any, val: any) => {
            acc.Adults += +val?.Adults || 0;
            acc.Children += +val?.Children || 0;
            return acc;
        }, { Adults: 0, Children: 0 }),
        [location?.state?.PaxRooms])

    const gethoteldetailsbybookingcode = async (code: any) => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            dispatch(loaderActions.start());
            const getdata = await postUsersData("/customerui/v1/gethoteldetailsbybookingcode", { 'BookingCode': code });
            const roomImages = getdata?.data?.hotelResult?.[0]?.hotelDetails?.[0]?.roomImages;

            getdata?.data?.hotelResult?.[0]?.rooms?.map((room: any) => {
                room.images = roomImages?.find((roomImg: any) => roomImg?.roomId === room?.tboRoomID)?.images || [];
                return room;
            })

            if (getdata?.status) {
                setGetDataList(getdata?.data ? getdata?.data?.hotelResult : [])
                const convinienceFees: any = {
                    isConvinienceFee: getdata?.data?.hotelResult?.[0]?.isConvinienceFee,
                    isConvinienceFeePercentage: getdata?.data?.hotelResult?.[0]?.isConvinienceFeePercentage,
                    convenienceFeesWeb: getdata?.data?.hotelResult?.[0]?.convenienceFeesWeb,
                    convenienceFeesMobileWeb: getdata?.data?.hotelResult?.[0]?.convenienceFeesMobileWeb,
                }
                setConvenienceDetail(convinienceFees);
                const user: any = GetLocalStorage();
                const form = {
                    BookingCode: code || "",
                    HotelBookingId: decryptUrlDatapattern(location?.state?.BookingId) || 0,
                    CheckInDate: location?.state?.CheckIn || null,
                    CheckoutDate: location?.state?.CheckOut || null,
                    BookingId: null,
                    InvoiceNumber: null,
                    ConfirmationNo: null,
                    BookingRefNo: null,
                    IsPriceChanged: false,
                    IsCancellationPolicyChanged: false,
                    Adults: passengerCount?.Adults || 0,
                    Children: passengerCount?.Children || 0,
                    BaseFare: getdata?.data?.hotelResult?.[0]?.rooms?.[0]?.basePrice || 0,
                    TotalFare: getdata?.data?.hotelResult?.[0]?.rooms?.[0]?.totalFare || 0,
                    TotalTax: getdata?.data?.hotelResult?.[0]?.rooms?.[0]?.totalTax || 0,
                    NetAmount: getdata?.data?.hotelResult?.[0]?.rooms?.[0]?.netAmount,
                    NetTax: getdata?.data?.hotelResult?.[0]?.rooms?.[0]?.netTax,
                    PriceWithMarkup: getdata?.data?.hotelResult?.[0]?.rooms?.[0]?.priceWithMarkup || 0,
                    MarkupCharges: getdata?.data?.hotelResult?.[0]?.rooms?.[0]?.markupCharges || 0,
                    GstCharges: getdata?.data?.hotelResult?.[0]?.rooms?.[0]?.gstCharges || 0,
                    FinalValue: getdata?.data?.hotelResult?.[0]?.rooms?.[0]?.grandTotal || 0,
                    Status: 0,
                    UserId: user?.userMasterID || 0,
                    NoOfRooms: location?.state?.PaxRooms?.length || 0,
                    HotelCode: getdata?.data?.hotelResult?.[0]?.hotelDetails?.[0]?.hotelCode || "",
                    HotelName: getdata?.data?.hotelResult?.[0]?.hotelDetails?.[0]?.hotelName || "",
                    HotelRating: getdata?.data?.hotelResult?.[0]?.hotelDetails?.[0]?.hotelRating || 0,
                    HotelAddress: getdata?.data?.hotelResult?.[0]?.hotelDetails?.[0]?.address || "",
                    PaxRooms: location?.state?.PaxRooms,
                    RateConditions: getdata?.data?.hotelResult?.[0]?.rateConditions
                }

                await postUsersData("/customerui/v1/insertorupdatehoteltravellerbooking", form);

                dispatch(loaderActions.end());
            }
            else {
                dispatch({ type: 'ALERTING', message: getdata?.message || APIBadMessage, redirectTo: '/' });
                dispatch(loaderActions.end());
            }
        }
        else {
            dispatch(loaderActions.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }
    }

    const getNight = useMemo(() => {
        const checkIn: any = new Date(location?.state?.CheckIn);
        const checkOut: any = new Date(location?.state?.CheckOut);

        const millisecondsPerDay = 1000 * 60 * 60 * 24;
        const nights = (checkOut - checkIn) / millisecondsPerDay;

        return nights
    }, [location?.state?.CheckIn, location?.state?.CheckOut])

    useEffect(() => {
        const payloadObjs = {
            "PaxRooms": location?.state?.PaxRooms,
        };
        setPersonCont(payloadObjs)
        localStorage.setItem("back", "false");
        if (!checkPathName) {
            gethoteldetailsbybookingcode(decryptUrlDatapattern(searchParams.get('code')))
        }
    }, [searchParams])


    //---------------------------------------------------*********************---------------------------------------------------------------/
    useEffect(() => {
        if (localStorage.getItem('back') === "true") {
            window.history.forward();
        }
    }, [])

    //#region convenience fee calculation
    const getConvenienceData = (hoteldata: any) => {
        let convinienceFeeCharged = 0
        if (convenienceDetail?.isConvinienceFee) {
            if (!convenienceDetail?.isConvinienceFeePercentage) {
                convinienceFeeCharged = Math.round((convenienceDetail?.convenienceFeesWeb + (convenienceDetail?.convenienceFeesWeb * 18 / 100)) * personcount?.PaxRooms?.length);
            }
            else {
                const convenienceFeePercentage = hoteldata?.rooms?.[0]?.grandTotal * convenienceDetail?.convenienceFeesWeb / 100
                convinienceFeeCharged = Math.round(convenienceFeePercentage + (convenienceFeePercentage * 18 / 100));
            }
        }

        return { convinienceFeeCharged: convinienceFeeCharged }
    }
    //#endregion


    //#region check validations function
    const validateData = () => {
        let status = true;
        let error: any = {};
        insertCollection?.map((el: any, indexa: any) => {
            const fullNames = el?.HotelPassenger?.map((p:any) => `${p.FirstName}${p.LastName}`) ?? [];
            const leadPassengerExists = el?.HotelPassenger?.some((p: any) => p.LeadPassenger === true);
            el?.HotelPassenger?.filter((el: any) => el.PaxType === 1)?.map((obj: any, index: any) => {
                if (obj.PaxType === 1) {
                    if (!leadPassengerExists) {
                        error[`lead${indexa + 1}${index + 1}`] = "Input is mandatory.";
                        status = false;
                    }
                    if (obj?.TitleId === 0) {
                        error[`hotelTitleSelectAdult${indexa + 1}${index + 1}`] = "Cannot leave blank, Please select title.";
                        status = false;
                    }

                    if (obj?.FirstName?.trim()?.length <= 0) {
                        error[`hotelFirstNameAdult${indexa + 1}${index + 1}`] = "Cannot leave blank, Please Provide First Name.";
                        status = false;
                    }
                    if (obj?.FirstName && obj?.FirstName?.trim()?.length < 2) {
                        error[`hotelFirstNameAdult${indexa + 1}${index + 1}`] = "Please Provide Valid First Name.";
                        status = false;
                    }

                    if (obj?.LastName?.trim()?.length <= 0) {
                        error[`hotelLastNameAdult${indexa + 1}${index + 1}`] = "Cannot leave blank, Please Provide Last Name.";
                        status = false;
                    }
                    if (obj?.LastName && obj?.LastName?.trim()?.length < 2) {
                        error[`hotelLastNameAdult${indexa + 1}${index + 1}`] = "Please Provide Valid Last Name.";
                        status = false;
                    }
                    if (obj?.CountryId === 0 || !obj?.CountryId) {
                        error[`hotelCountryAdult${indexa + 1}${index + 1}`] = "Cannot leave blank, please select country.";
                        status = false;
                    }
                    if (obj?.Phoneno?.trim()?.length <= 0 && obj.LeadPassenger) {
                        error[`hotelContactNoAdult${indexa + 1}${index + 1}`] = "Cannot leave blank, please provide mobile number.";
                        status = false;
                    }
                    else if (obj?.Phoneno?.trim()?.length > 0 && obj.Phoneno?.trim()?.length < 10) {
                        error[`hotelContactNoAdult${indexa + 1}${index + 1}`] = "Please enter valid mobile number.";
                        status = false;
                    }
                    if (obj.Email?.trim()?.length <= 0 && obj.LeadPassenger) {
                        error[`hotelEmailIdAdult${indexa + 1}${index + 1}`] = "Cannot leave blank, please provide email ID.";
                        status = false;
                    }
                    if (obj?.Email && !isValidEmail(obj?.Email)) {
                        error[`hotelEmailIdAdult${indexa + 1}${index + 1}`] = "Please enter valid email ID.";
                        status = false;
                    }
                    if (obj?.Age === 0) {
                        error[`hotelAgeAdult${indexa + 1}${index + 1}`] = "Please provide valid Age.";
                        status = false;
                    }
                    //#region Passport validation
                    // if (obj?.CountryId > 1 && !isinternationalhotel) {
                    if (showPassport(obj?.CountryId)) {
                        if (obj?.PassportNo?.trim()?.length <= 0) {
                            error[`hotelPassportNumberAdult${indexa + 1}${index + 1}`] = "Cannot leave blank, please provide your passport number.";
                            status = false;
                        }
                        if (obj?.PassportNo?.trim()?.length > 0 && (obj?.PassportNo?.trim()?.length < 6 || obj?.PassportNo?.trim()?.length > 10)) {
                            error[`hotelPassportNumberAdult${indexa + 1}${index + 1}`] = "Please enter valid passport number.";
                            status = false;
                        }
                        if (obj?.PassportNo?.trim()?.length <= 0 && (obj?.tempPassportIssueDate !== "" || obj?.tempExpiryDate !== ""
                            // || obj?.PassportIssueCountryCode !== ""
                        )) {
                            error[`hotelPassportNumberAdult${indexa + 1}${index + 1}`] = "Cannot leave blank, please provide your passport number.";
                            status = false;
                        }
                        if (obj?.tempPassportIssueDate === "") {
                            error[`hotelPassportIssueDateAdult${indexa + 1}${index + 1}`] = "Cannot leave blank, please provide issuance date.";
                            status = false;
                        }
                        if (obj?.PassportNo?.trim()?.length > 0 && obj?.tempPassportIssueDate === "") {
                            error[`hotelPassportIssueDateAdult${indexa + 1}${index + 1}`] = "Cannot leave blank, please provide issuance date.";
                            status = false;
                        }
                        if (obj?.tempExpiryDate === "") {
                            error[`hotelPassportExpiryAdult${indexa + 1}${index + 1}`] = "Cannot leave blank, please provide expiry date.";
                            status = false;
                        }
                        if (obj?.PassportNo?.trim()?.length > 0 && obj?.tempExpiryDate === "") {
                            error[`hotelPassportExpiryAdult${indexa + 1}${index + 1}`] = "Cannot leave blank, please provide expiry date.";
                            status = false;
                        }
                        if (obj?.PassportNo?.trim()?.length > 0 && obj?.tempExpiryDate?.length > 0 && !(new Date(obj.tempPassportIssueDate) < new Date(obj.tempExpiryDate))) {
                            error[`hotelPassportExpiryAdult${indexa + 1}${index + 1}`] = "Please enter valid passport expiry date.";
                            status = false;
                        }
                    }
                    //#endregion
                    // if ((validationInfo?.panMandatory && obj.PAN?.trim()?.length === 0) || (obj.PAN && !isValidPAN(obj.PAN))) {
                    // if (obj?.CountryId === 1 && isinternationalhotel) {
                    if (showPAN(obj?.CountryId)) {
                        if (obj?.PAN?.trim()?.length === 0 || (obj?.PAN && !isValidPAN(obj?.PAN))) {
                            error[`hotelPANAdult${indexa + 1}${index + 1}`] = "Please enter valid PAN Number.";
                            status = false;
                        }
                    }
                }
            })
            el?.HotelPassenger?.filter((el: any) => el.PaxType === 2)?.map((obj: any, index: any) => {
                if (obj.PaxType === 2) {
                    if (obj?.TitleId === 0) {
                        error[`hotelTitleSelectChild${indexa + 1}${index + 1}`] = "Input is mandatory.";
                        status = false;
                    }
                    if (obj?.FirstName?.trim()?.length <= 0) {
                        error[`hotelFirstNameChild${indexa + 1}${index + 1}`] = "Cannot leave blank, input is mandatory.";
                        status = false;
                    }
                    if (obj?.FirstName && obj?.FirstName?.trim()?.length < 2) {
                        error[`hotelFirstNameChild${indexa + 1}${index + 1}`] = "Please Provide Valid First Name.";
                        status = false;
                    }
                    if (obj?.LastName?.trim()?.length <= 0) {
                        error[`hotelLastNameChild${indexa + 1}${index + 1}`] = "Cannot leave blank, input is mandatory.";
                        status = false;
                    }
                    if (obj?.LastName && obj?.LastName?.trim()?.length < 2) {
                        error[`hotelLastNameChild${indexa + 1}${index + 1}`] = "Please Provide Valid Last Name.";
                        status = false;
                    }
                    if (obj?.Age === 0) {
                        error[`hotelAgeChild${indexa + 1}${index + 1}`] = "Please provide valid Age.";
                        status = false;
                    }
                    if (obj?.CountryId === 0 || !obj?.CountryId) {
                        error[`hotelCountryChild${indexa + 1}${index + 1}`] = "Cannot leave blank, please select country.";
                        status = false;
                    }
                    if (showPassport(obj?.CountryId)) {
                        if (obj?.PassportNo?.trim()?.length <= 0) {
                            error[`hotelPassportNumberChild${indexa + 1}${index + 1}`] = "Cannot leave blank, please provide your passport number.";
                            status = false;
                        }
                        if (obj?.PassportNo?.trim()?.length > 0 && (obj?.PassportNo?.trim()?.length < 6 || obj?.PassportNo?.trim()?.length > 10)) {
                            error[`hotelPassportNumberChild${indexa + 1}${index + 1}`] = "Please enter valid  passport number.";
                            status = false;
                        }
                        if (obj?.PassportNo?.trim()?.length <= 0 && (obj?.tempPassportIssueDate !== "" || obj?.tempExpiryDate !== ""
                            // || obj?.PassportIssueCountryCode !== ""
                        )) {
                            error[`hotelPassportNumberChild${indexa + 1}${index + 1}`] = "Cannot leave blank, please provide your passport number.";
                            status = false;
                        }
                        if (obj?.tempPassportIssueDate === "") {
                            error[`hotelPassportIssueDateChild${indexa + 1}${index + 1}`] = "Cannot leave blank, please provide issuance date.";
                            status = false;
                        }
                        if (obj?.PassportNo?.trim()?.length > 0 && obj?.tempPassportIssueDate === "") {
                            error[`hotelPassportIssueDateChild${indexa + 1}${index + 1}`] = "Cannot leave blank, please provide issuance date.";
                            status = false;
                        }
                        if (obj?.tempExpiryDate === "") {
                            error[`hotelPassportExpiryChild${indexa + 1}${index + 1}`] = "Cannot leave blank, please provide expiry date.";
                            status = false;
                        }
                        if (obj?.PassportNo?.trim()?.length > 0 && obj?.tempExpiryDate === "") {
                            error[`hotelPassportExpiryChild${indexa + 1}${index + 1}`] = "Cannot leave blank, please provide expiry date.";
                            status = false;
                        }
                        if (obj?.PassportNo?.trim()?.length > 0 && obj?.tempExpiryDate?.length > 0 && !(new Date(obj.tempPassportIssueDate) < new Date(obj.tempExpiryDate))) {
                            error[`hotelPassportExpiryChild${indexa + 1}${index + 1}`] = "Please enter valid passport expiry date.";
                            status = false;
                        }
                    }
                    // if ((validationInfo?.panMandatory && obj.PAN?.trim()?.length === 0) || (obj.PAN && !isValidPAN(obj.PAN))) {
                    // if (obj?.CountryId === 1 && isinternationalhotel) {
                    if (showPAN(obj?.CountryId)) {
                        if (obj?.PAN?.trim()?.length === 0 || (obj?.PAN && !isValidPAN(obj?.PAN))) {
                            error[`hotelPANChild${indexa + 1}${index + 1}`] = "Please enter valid PAN Number.";
                            status = false;
                        }
                    }
                }
            })
            if ((fullNames?.length !== new Set(fullNames)?.size) && fullNames?.length > 1) {
                dispatch({ type: 'ALERTING', message: "Passenger name cannot be same." });
                status = false;
            }
        })

        if (formValue?.CountryId <= 0) {
            error["CountryId"] = "Cannot leave blank, please select country code.";
            status = false;
        }
        if (formValue?.FirstName?.trim()?.length <= 0) {
            error["FirstName"] = "Cannot leave blank, please provide First Name.";
            status = false;
        }
        if (formValue?.FirstName && formValue?.FirstName?.trim()?.length < 2) {
            error["FirstName"] = "Please Provide Valid First Name.";
            status = false;
        }
        if (formValue?.LastName?.trim()?.length <= 0) {
            error["LastName"] = "Cannot leave blank, please provide Last Name.";
            status = false;
        }
        if (formValue?.LastName && formValue?.LastName?.trim()?.length < 2) {
            error["LastName"] = "Please Provide Valid Last Name.";
            status = false;
        }
        if (formValue?.MobileNo?.trim()?.length <= 0) {
            error["MobileNo"] = "Cannot leave blank, please provide mobile number.";
            status = false;
        }
        else if (formValue?.MobileNo?.trim()?.length > 0 && formValue.MobileNo?.trim()?.length < 10) {
            error["MobileNo"] = "Please provide valid mobile number.";
            status = false;
        }
        if (formValue?.Email?.trim()?.length === 0) {
            error["Email"] = "Cannot leave blank, please provide email id.";
            status = false;
        }
        else if (formValue?.Email?.trim()?.length > 0 && !isValidEmail(formValue?.Email)) {
            error["Email"] = "Please provide valid email ID.";
            status = false;
        }
        if (formValue?.IsGST === true) {
            if (formValue?.GSTNumber?.trim()?.length === 0) {
                error["GSTNumber"] = "Cannot leave blank, please provide GST Number.";
                status = false;
            }
            if (formValue?.GSTNumber && !gstinregex.test(formValue?.GSTNumber)) {
                error["GSTNumber"] = "Please enter valid GST Number.";
                status = false;
            }
            if (formValue?.GSTNumber?.trim()?.length > 0 && formValue?.GSTCompanyName?.trim()?.length <= 0) {
                error["GSTCompanyName"] = "Cannot leave blank, please provide GST Company Name.";
                status = false;
            }
            if (formValue?.GSTNumber?.trim()?.length > 0 && formValue?.GSTCompanyContactNumber?.trim()?.length <= 0) {
                error["GSTCompanyContactNumber"] = "Cannot leave blank, please provide GST Company Contact Number.";
                status = false;
            }
            else if (formValue?.GSTNumber?.trim()?.length > 0 && formValue?.GSTCompanyContactNumber?.trim()?.length > 0 && formValue?.GSTCompanyContactNumber?.trim()?.length < 10) {
                error["GSTCompanyContactNumber"] = "Please provide valid GST Company Contact Number.";
                status = false;
            }
            if (formValue?.GSTNumber?.trim()?.length > 0 && formValue?.GSTCompanyEmail?.trim()?.length <= 0) {
                error["GSTCompanyEmail"] = "Cannot leave blank, please provide GST Company Email.";
                status = false;
            }
            if (formValue?.GSTCompanyEmail && !isValidEmail(formValue?.GSTCompanyEmail)) {
                error["GSTCompanyEmail"] = "Please enter valid email ID.";
                status = false;
            }
            if (formValue?.GSTNumber?.trim()?.length > 0 && formValue?.GSTCompanyAddress?.trim()?.length <= 0) {
                error["GSTCompanyAddress"] = "Cannot leave blank, please provide GST Company Address.";
                status = false;
            }
        }
        if (Object.keys(error)?.length > 0) {
            document.getElementById(Object.keys(error)[0])?.focus();
        }
        setFormError(error);
        return status;
    }

    const validForeignNationality = () => {
        let status = true
        let error: any = {}
        const travelerCountryIds = insertCollection?.reduce((acc: any, curr: any) => {
            const CountryIds = curr?.HotelPassenger?.filter((obj: any) => obj?.CountryId !== 1)
            acc = [...acc, ...CountryIds]
            return acc;
        }, [])
        if (travelerCountryIds?.length > 0 && isinternationalhotel) {
            error.foreignNationality = foreignNationalityMessage
            status = false
            window.scrollTo({ left: 0, top: 0 });
        }

        setFormError(error);
        return status;
    }
    //#endregion

    const handleContinue = async (isOnHold: any, hoteldata: any) => {
        if (validateData() && validForeignNationality()) {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                const user: any = GetLocalStorage();
                const decryptBookingId = decryptUrlDatapattern(location?.state?.BookingId);

                const travellerBookingData = {
                    HotelBookingId: decryptBookingId,
                    PriceWithMarkup: hoteldata?.rooms?.[0]?.priceWithMarkup,
                    MarkupCharges: hoteldata?.rooms?.[0]?.markupCharges,
                    GstCharges: hoteldata?.rooms?.[0]?.gstCharges,
                    ConvenienceFee: getConvenienceData(hoteldata)?.convinienceFeeCharged || 0,
                    FinalValue: (hoteldata?.rooms?.[0]?.grandTotal) + (getConvenienceData(hoteldata)?.convinienceFeeCharged ? getConvenienceData(hoteldata)?.convinienceFeeCharged : 0),
                    UserId: user?.userMasterID
                }

                const updatehotelfinalprice = await postUsersData('/customerui/v1/updatehotelfinalprice', travellerBookingData);
                if (updatehotelfinalprice?.status) {

                    const data = {
                        BookingId: decryptBookingId,
                        UserId: user?.userMasterID,
                        HotelRoomsDetails: insertCollection,
                        ContactDetails: {
                            FirstName: formValue?.FirstName,
                            LastName: formValue?.LastName,
                            CountryId: formValue?.CountryId,
                            MobileNumber: formValue?.MobileNo,
                            EmailId: formValue?.Email,
                        },
                    }
                    const insertupdatetravellerdetails = await postUsersData("/customerui/v1/insertorupdatehoteltravellerdetail", data);
                    if (insertupdatetravellerdetails?.status) {
                        localStorage.setItem("back", "true")
                        sessionStorage.setItem('passengers', JSON.stringify(data?.HotelRoomsDetails))
                        sessionStorage.setItem('others', JSON.stringify(formValue))

                        const bookingParameter = {
                            BookingId: decryptBookingId,
                            UserId: user?.userMasterID
                        }

                        if (isOnHold) {
                            const bookingnumberforholdbooking = await postUsersData('/customerui/v1/getbookingnumberforholdbooking', bookingParameter)
                            if (bookingnumberforholdbooking?.status) {
                                localStorage.setItem("last", "false")

                                const onHoldParameter = {
                                    BookingId: decryptBookingId,
                                    ResponseType: 3,
                                    PaymentId: bookingnumberforholdbooking?.data?.[0]?.PaymentId,
                                    BookingStatus: 9,
                                    IsVoucherBooking: false,
                                    UserId: user?.userMasterID
                                }

                                bookingHotelInTBO(onHoldParameter, true, hoteldata);
                            }
                            else {
                                dispatch({ type: 'ALERTING', message: 'Something went wrong, Please try again!', redirectTo: '/' });
                                dispatch(loaderActions.end());
                            }
                        }
                        else {
                            localStorage.setItem('isOpen', `${location?.state?.BookingId}`)
                            localStorage.setItem('isOpenDup', 'true')

                            callPaymentGateway(bookingParameter, hoteldata)
                        }
                    }
                    else {
                        dispatch({ type: 'ALERTING', message: insertupdatetravellerdetails.message || APIBadMessage, redirectTo: '/' });
                        dispatch(loaderActions.end());
                    }

                }
                else {
                    dispatch({ type: 'ALERTING', message: updatehotelfinalprice?.message || APIBadMessage, redirectTo: '/' });
                    dispatch(loaderActions.end());
                }

            }
            else {
                dispatch(loaderActions.end());
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            }

        }
    }

    const callPaymentGateway = async (bookingParameter: any, hoteldata: any) => {
        dispatch(loaderActions.start());
        await postUsersData('/customerui/v1/gethotelbookingparameter', bookingParameter).then((res) => {
            if (res?.status) {
                localStorage.setItem("temp", encryptUrlDatapattern(res?.data[0]?.PaymentId))
                localStorage.setItem("last", "false")
                if (document.getElementsByTagName("body")[0]?.classList?.contains("overflow-auto")) {
                    document.getElementsByTagName("body")[0]?.classList?.remove("overflow-auto")
                }
                checkoutjs(res?.data[0], true, hoteldata);
            }
            else {
                dispatch({ type: 'ALERTING', message: 'Something went wrong, Please try again!', redirectTo: '/' });
                dispatch(loaderActions.end());
            }
        })

        handlePage('payment')
    }

    //#region checkout razorpay along with add the razorpay's script
    const checkoutjs = (data: any, isScript: any, hoteldata: any) => {
        if (isScript) {
            const script = document.createElement('script');
            script.src = data?.Website;
            script.async = true;
            script.id = "Website";
            script.onload = (e) => paymentCheckout(e, data, hoteldata);
            document.body.appendChild(script);
        }
        else {
            const isRetry = encryptUrlDatapattern("false");
            localStorage.setItem("isRetry", isRetry);
            const doc = document.getElementById("Website")
            doc?.parentNode?.removeChild(doc);
        }
    }
    //#endregion

    //#region open the razor pay portal and handle the success and failed response
    const paymentCheckout = async (e: any, data: any, hoteldata: any) => {
        const user: any = GetLocalStorage();

        const options = {
            key: data?.MerchantId, // Enter the Key ID generated from the Dashboard
            amount: data?.BookingAmount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            currency: data?.Currency,
            name: data?.BookingTitle, //your business name
            order_id: data?.OrderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            image: require('../../../../assets/img/etm-logo1.png'),
            // "callback_url": "http://localhost:4000/api/callback",
            handler: async function (response: any) {
                const razorpayresponsedata = {
                    PaymentId: data?.PaymentId,
                    BookingId: data?.BookingId,
                    ResponseType: 1,
                    key_id: data?.MerchantId,
                    key_secret: data?.MerchantKey,
                    razorpay_payment_id: response?.razorpay_payment_id,
                    razorpay_order_id: response?.razorpay_order_id,
                    razorpay_signature: response?.razorpay_signature,
                    UserId: user?.userMasterID
                }
                rezorPayResponse(razorpayresponsedata, data, e, hoteldata)
            },
            prefill: { //We recommend using the prefill parameter to auto-fill customer's contact information, especially their phone number
                name: `${formValue?.FirstName} ${formValue?.LastName}` || "", //your customer's name
                email: formValue?.Email || "", //your customer's email
                contact: formValue?.MobileNo || ""  //Provide the customer's phone number for better conversion rates 
            },
            notes: {
                GSTNumber: formValue?.GSTNumber || "",
                GSTCompanyName: formValue?.GSTCompanyName || "",
                GSTCompanyEmail: formValue?.GSTCompanyEmail || "",
                GSTCompanyContactNumber: formValue?.GSTCompanyContactNumber || "",
                GSTCompanyAddress: formValue?.GSTCompanyAddress || "",
            },
            theme: {
                color: "#3399cc"
            },
            modal: {
                ondismiss: function (response: any) {
                    checkoutjs(data, false, hoteldata)
                    if (localStorage.getItem('isOpen') === `${location?.state?.BookingId}` && localStorage.getItem('isOpenDup') === "true") {
                        for (let i = 0; i < razorpopup?.length; i++) {
                            razorpopup[i]?.parentNode?.removeChild(razorpopup[i]);
                        }
                    }
                    rezorPayClose(data?.PaymentId, user?.userMasterID);
                }
            }
        };

        const rzp = new (window as any).Razorpay(options)
        rzp.open();
        e.preventDefault();
        localStorage.setItem('isOpenDup', 'true')

        rzp.on('payment.failed', function (response: any) {

            const razorpayresponsedata = {
                PaymentId: data?.PaymentId,
                BookingId: data?.BookingId,
                ResponseType: 0,
                key_id: data?.MerchantId,
                key_secret: data?.MerchantKey,
                razorpay_payment_id: response?.error?.metadata?.payment_id,
                razorpay_order_id: response?.error?.metadata?.order_id,
                razorpay_signature: "",
                UserId: user?.userMasterID
            }
            rezorPayResponse(razorpayresponsedata, data, e, hoteldata);
        });
        dispatch(loaderActions.end())
    }
    //#endregion


    //#region call api for insert the razorpay response in the database
    const rezorPayResponse = async (razorpayresponsedata: any, data: any, e: any, hoteldata: any) => {
        for (let i = 0; i < razorpopup?.length; i++) {
            razorpopup[i]?.parentNode?.removeChild(razorpopup[i]);
        }

        document.getElementsByTagName("body")[0].classList.add("overflow-auto")

        dispatch(loaderActions.start())
        const paymentResponse = await postUsersData('/customerui/v1/hotelrazorpayresponse', razorpayresponsedata)

        if (paymentResponse?.status) {
            checkoutjs(data, false, hoteldata)
            if (razorpayresponsedata?.ResponseType === 1) {
                bookingHotelInTBO({ ...razorpayresponsedata, BookingId: data?.BookingId, IsVoucherBooking: true }, false, hoteldata);
            }
            else {
                navigate(`/hotel/failed?${newSearchParams?.toString()}`, {
                    state: {
                        payment: 'failed',
                        BookingId: location?.state?.BookingId,
                        ResponseType: razorpayresponsedata?.ResponseType,
                        PaymentId: razorpayresponsedata?.PaymentId,
                    }
                });
            }
            dispatch(loaderActions.end());
        }
        else {
            dispatch({ type: 'ALERTING', message: 'Something went wrong, Please try again!', redirectTo: '/' })
            dispatch(loaderActions.end());
        }
    }

    const rezorPayClose = async (paymentid: any, userId: any) => {
        for (let i = 0; i < razorpopup?.length; i++) {
            razorpopup[i]?.parentNode?.removeChild(razorpopup[i]);
        }
        document.getElementsByTagName("body")[0].classList.add("overflow-auto")

        dispatch(loaderActions.start())
        const closedata = {
            PaymentId: paymentid,
            BookingId: decryptUrlDatapattern(location?.state?.BookingId),
            UserId: userId
        }
        const closeResponse = await postUsersData('/customerui/v1/gethotelrazorpayclose', closedata);
        if (closeResponse?.status) {
            navigate(`/hotel/failed?${newSearchParams?.toString()}`, {
                state: {
                    payment: 'failed',
                    BookingId: location?.state?.BookingId,
                    ResponseType: 0,
                    PaymentId: paymentid,
                    isRetryPayment: false
                }
            });
        }
        else {
            dispatch({ type: 'ALERTING', message: 'Something went wrong, Please try again!', redirectTo: '/' })
        }
        dispatch(loaderActions.end())
    }

    const bookingHotelInTBO = async (razorpayresponsedata: any, isOnHold: any, hoteldata: any) => {
        dispatch(loaderActions.start());
        const statusoftoken = await verifytoken();

        if (statusoftoken) {
            const userip = await fetchIp();
            if (userip?.status) {
                const hotelObj: any = {
                    HotelBookingId: razorpayresponsedata?.BookingId,
                    BookingCode: hoteldata?.rooms?.[0]?.bookingCode,
                    IsVoucherBooking: razorpayresponsedata?.IsVoucherBooking,  // for hold the booking pass false to IsVoucherBooking otherwise true, 
                    GuestNationality: "IN",
                    EndUserIp: userip?.data,
                    RequestedBookingMode: 5,  //change to 5 for certification
                    netAmount: hoteldata?.rooms?.[0]?.netAmount,
                    HotelRoomsDetails: passengersData?.reduce((acc: any, room: any) => {
                        acc.push({
                            HotelPassenger: room?.HotelPassenger?.map((passengers: any) => ({
                                Title: passengers?.Title,
                                FirstName: passengers?.FirstName,
                                MiddleName: "",
                                LastName: passengers?.LastName,
                                Email: passengers?.Email,
                                PaxType: passengers?.PaxType,
                                LeadPassenger: passengers?.LeadPassenger,
                                DateOfBirth: passengers?.DateOfBirth,
                                Age: passengers?.Age,
                                PassportNo: passengers?.PassportNo,
                                PassportIssueDate: passengers?.PassportIssueDate,
                                PassportExpDate: passengers?.PassportExpDate,
                                Phoneno: passengers?.Phoneno,
                                PaxId: passengers?.PaxId,
                                GSTCompanyAddress: passengers?.GSTCompanyAddress || null,
                                GSTCompanyContactNumber: passengers?.GSTCompanyContactNumber || null,
                                GSTCompanyName: passengers?.GSTCompanyName || null,
                                GSTNumber: passengers?.GSTNumber || null,
                                GSTCompanyEmail: passengers?.GSTCompanyEmail || null,
                                PAN: passengers?.PAN
                            }))
                        })
                        return acc
                    }, [])
                }
                dispatch(loaderActions.start());
                const hotelBooked = await postUsersData("/customerui/v1/hotelbooking", hotelObj);
                if (hotelBooked?.status) {
                    if (isOnHold) {
                        navigate(`/hotel/on-hold?${newSearchParams?.toString()}`, {
                            state: {
                                payment: 'onHold',
                                BookingId: location?.state?.BookingId,
                                ResponseType: razorpayresponsedata?.ResponseType,
                                PaymentId: razorpayresponsedata?.PaymentId,
                                hotelBookingId: hotelBooked?.data?.bookResult?.bookingId
                            }
                        });
                    }
                    else {
                        navigate(`/hotel/Booking-successful?${newSearchParams?.toString()}`, {
                            state: {
                                payment: 'success',
                                BookingId: location?.state?.BookingId,
                                ResponseType: razorpayresponsedata?.ResponseType,
                                PaymentId: razorpayresponsedata?.PaymentId,
                                hotelBookingId: hotelBooked?.data?.bookResult?.bookingId,
                                rateConditions: hoteldata?.rateConditions,
                                cancelPolicies: hoteldata?.rooms?.[0]?.cancelPolicies
                            }
                        });
                    }
                    dispatch(loaderActions.end());
                }
                else {
                    navigate(`/hotel/pending?${newSearchParams?.toString()}`, {
                        state: {
                            payment: 'pending',
                            BookingId: location?.state?.BookingId,
                            ResponseType: 2,
                            PaymentId: razorpayresponsedata?.PaymentId,
                            BookingStatus: 7
                        }
                    });
                    dispatch(loaderActions.end());
                }
            }
            else {
                dispatch({ type: 'ALERTING', message: 'Something went wrong, Please try again!', redirectTo: '/' });
            }
        }
        else {
            dispatch(loaderActions.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }
    }
    //#endregion


    const checkLastCancellationDateForHold = (hoteldata: any) => {
        const lastCancellation = hoteldata?.rooms?.[0]?.lastCancellationDeadline;
        if (lastCancellation) {
            const lastCancellationDay = lastCancellation?.split(" ")?.[0]
            const [date, month, year] = lastCancellationDay?.split("-")?.map((obj: any) => Number(obj));
            const lastCancellationDateOnly = new Date(year, month - 1, date - 1)

            const today = new Date();
            const dateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const condition = lastCancellationDateOnly > dateOnly
            return condition;
        }
        else {
            return false;
        }
    }

    //#region after open the razor pay gateway when user refresh the page then payment is going to failed.
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        if (!checkPathName) {
            if (localStorage.getItem('isOpen') === `${location?.state?.BookingId}` && localStorage.getItem('isOpenDup') === "true") {
                const paymentid = localStorage?.getItem("temp") && Number(decryptUrlDatapattern(localStorage?.getItem("temp")))
                const user: any = GetLocalStorage()
                const doc = document.getElementById("Website")
                doc?.parentNode?.removeChild(doc);

                rezorPayClose(paymentid, user?.userMasterID)
            }
            else {
                const isRetry = localStorage.getItem("isRetry") !== null ? decryptUrlDatapattern(localStorage.getItem("isRetry")) : null;
                if (location?.state?.isRetryPayment && isRetry === "true") {
                    const user: any = GetLocalStorage();
                    const bookingParameter = {
                        BookingId: decryptUrlDatapattern(location?.state?.BookingId),
                        UserId: user?.userMasterID
                    }
                    callPaymentGateway(bookingParameter, getDataList?.[0]);
                }
            }
        }

        if (localStorage.getItem('isOpen') === `${location?.state?.BookingId}`) {
            window.history.forward();
        }
    }, [location?.state?.isRetryPayment])
    //#endregion
    return (
        <>
            <section className={`${!checkPathName ? 'midSection' : ''} `}>
                <div className={` ${!checkPathName ? 'container' : ''}`}>
                    {
                        !checkPathName &&
                        <ul className="breadcrumb mb-3">
                            <li className={` 
                                ${(location?.pathname?.includes('travellers') || location?.pathname?.includes('review') || location?.pathname?.includes('payment')) ? 'active' : ''}`}
                            >
                                <button type='button' className='btn p-0' onClick={() => handlePage('review')} >Review</button>
                            </li>

                            <li className={` ${location?.pathname?.includes('payment') ? 'active' : ''}`} >
                                <div>Payment</div>
                            </li>
                        </ul>
                    }

                    <Routes>
                        <Route path="review" element={<BookingRoomDetails
                            getDataList={getDataList}
                            setFormValue={setFormValue}
                            formValue={formValue}
                            setFormError={setFormError}
                            formError={formError}
                            setInsertCollection={setInsertCollection}
                            insertCollection={insertCollection}
                            setInitialData={setInitialData}
                            initialData={initialData}
                            setIntOtherData={setIntOtherData}
                            intOtherData={intOtherData}
                            handleContinue={handleContinue}
                            personcount={personcount}
                            getNight={getNight}
                            setPassengersData={setPassengersData}
                            convenienceDetail={convenienceDetail}
                            checkLastCancellationDateForHold={checkLastCancellationDateForHold}
                        />} />
                        <Route path="payment" element={<div>Payment</div>} />
                    </Routes>

                </div>
            </section>
            <Routes>
                <Route path="Booking-successful" element={<HotelBookingConfirmation />} />
                <Route path="failed" element={<HotelBookingConfirmation />} />
                <Route path="pending" element={<HotelBookingConfirmation />} />
                <Route path="on-hold" element={<HotelBookingConfirmation />} />
            </Routes>

        </>
    )
}

export default HotelsDetailsReview